import { render } from "./App.vue?vue&type=template&id=dde3b4be"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=dde3b4be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/config-app/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dde3b4be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dde3b4be', __exports__)) {
    api.reload('dde3b4be', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=dde3b4be", () => {
    api.rerender('dde3b4be', render)
  })

}


export default __exports__